import { render } from "./PositionAndDevice.vue?vue&type=template&id=8080702a&scoped=true"
import script from "./PositionAndDevice.vue?vue&type=script&lang=js"
export * from "./PositionAndDevice.vue?vue&type=script&lang=js"

import "./PositionAndDevice.vue?vue&type=style&index=0&id=8080702a&lang=scss&scoped=true"
import "./PositionAndDevice.vue?vue&type=style&index=1&id=8080702a&lang=css"

import exportComponent from "/data/projects/dev_private_futurelab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8080702a"]])

export default __exports__